<template>
    <div class="badge text-nowrap user-select-none"
         :style="`background-color: ${backgroundColorStyleValue}; color: ${textColor}; ${shadowStyle}`">
        <OrderTypeIcon v-if="!hideIcon" class="mr-1 text-inherit" :type="type"/>
        <span class="font-weight-bolder text-uppercase">
            <span v-if="$slots.default">
                <slot />
            </span>
            <span v-else>
                {{ __('orders.types.' + type) }}
            </span>
        </span>
    </div>
</template>

<script>
import OrderTypeIcon from '@components/Orders/OrderTypeIcon.vue';

export default {
    components: {
        OrderTypeIcon,
    },

    props: {
        type: String,
        hideIcon: Boolean,
        light: Boolean,
        shadow: Boolean,
        bgAlpha: {
            type: Number,
            default: 0.125
        }
    },

    computed: {
        backgroundColorCode() {
            return this.$page.props.order_types[this.type]
        },

        textColor() {
            if (this.light) {
                return this.backgroundColorCode;
            }

            return '#fff';
        },

        backgroundColorStyleValue() {
            if (this.light) {
                let r = parseInt(this.backgroundColorCode.slice(1, 3), 16),
                    g = parseInt(this.backgroundColorCode.slice(3, 5), 16),
                    b = parseInt(this.backgroundColorCode.slice(5, 7), 16);

                return `rgba(${r},${g},${b},${this.bgAlpha});`
            }

            return this.backgroundColorCode;
        },

        shadowStyle() {
            if (this.shadow) {
                return `box-shadow: 0 .1rem 1rem 0.25rem ${this.backgroundColorStyleValue};`
            }

            return null;
        }
    }
};
</script>
